import { z } from 'zod';

export const legalTransactionRelationshipData = z
  .object({
    ThirdPartyClauseText: z.string().optional().nullable(),
    withThirdPartyClause: z.boolean().optional(),
  })
  .passthrough();

export type ILegalTransactionRelationshipData = z.infer<
  typeof legalTransactionRelationshipData
>;
